<template>
  <div class="partner-organisation mb-5">
    <CCard class="mt-2">
      <CCardBody>
        <CRow>
          <CCol lg="6">
            <CRow class="mb-3">
              <label class="col-lg-12 col-md-12">Organisation Type</label>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <Select
                  name="organisation_type_id"
                  :value="customer.organisation_type_id"
                  :options="
                    options && options['organization_type']
                      ? options['organization_type']
                      : []
                  "
                  :multiple="false"
                  :clearable="true"
                  @input="handleChangeSelect"
                />
              </div>
            </CRow>
          </CCol>
        </CRow>

        <div class="mb-2 pb-2">
          <CDataTable
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :items="partners"
            :fields="fields"
            :items-per-page="limit"
            sorter
            :tableFilter="{
              label: 'Search',
              placeholder: 'Type for search',
            }"
            pagination
            class="px-1 pb-2 border"
          >
            <template #action="{ item, index }">
              <td class="py-2">
                <div class="d-flex">
                  <CButton
                    color="primary"
                    square
                    size="sm"
                    class="mr-1"
                    v-if="item.rawData.current_status === 'request'"
                    @click="openRequestModal(item.rawData, true)"
                    >Request</CButton
                  >
                  <CButton
                    color="secondary"
                    square
                    size="sm"
                    class="mr-1"
                    v-if="item.rawData.current_status === 'pending'"
                    @click="openRequestModal(item.rawData,false)"
                    >Cancel</CButton
                  >
                </div>
              </td>
            </template>
            <template #footer>
              <tr>
                <td colspan="100%">Total Records: {{ partners.length }}</td>
              </tr>
            </template>
          </CDataTable>
        </div>
      </CCardBody>
    </CCard>
    <Modal
      :modalTitle="confirmModal.modalTitle"
      :modalColor="confirmModal.modalColor"
      :modalContent="confirmModal.modalContent"
      :isShowPopup="confirmModal.isShowPopup"
      :buttons="confirmModal.buttons"
      :modalCallBack="confirmModalCallBack"
      :closeOnBackdrop="false"
    />
  </div>
</template>
<script>
import Vue from "vue";
import Select from "@/components/reusable/Fields/Select.vue";
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import Modal from "@/components/reusable/Modal";

export default {
  components: {
    Select,
    Modal,
  },
  data() {
    return {
      customer: {
        organisation_type_id: null,
      },
      page: 1,
      perPage: 10,
      total: 0,

      limit: 10,
      small: true,
      striped: true,
      bordered: true,
      fields: [
        {
          key: "name",
          label: "Name",
          _style: "width:20%",
        },
        {
          key: "type",
          label: "Type",
          _style: "width:15%",
        },
        {
          key: "location",
          label: "Location",
          _style: "width:20%",
        },
        {
          key: "main_contact",
          label: "Main Contact",
          _style: "width:20%",
        },
        {
          key: "status",
          label: "Status",
          _style: "width:10%",
        },
        {
          key: "action",
          label: "Action",
          _style: "width:15%",
        },
      ],
      confirmModal: {
        modalColor: "primary",
        modalTitle: "Confirmation",
        modalContent: "Are you sure to raise the partner request?",
        isShowPopup: false,
        buttons: ["Cancel", "Confirm"],
        data: null,
        status: null,
      },
    };
  },
  computed: {
    ...mapGetters([
      "getOrganisationTypeList",
      "getNonCustOrgPartnerRelationship",
      "getOrgTypeIDFromAccessToken",
      "getOrgDetail",
    ]),
    options() {
      return {
        organization_type: this.customOrganisationTypeList || [],
      };
    },
    customOrganisationTypeList() {
      return this.getOrganisationTypeList.filter(({ code }) =>
        [1, 3, 18].includes(code),
      );
    },
    partners() {
      const organisation_type_id = this.customer?.organisation_type_id?.code ? [this.customer?.organisation_type_id?.code] : [1, 3, 18];
      return (
        this.getNonCustOrgPartnerRelationship.filter((item) =>
            organisation_type_id.includes(item?.organisation_type_id)
        ) || []
      ).map((item) => ({
        name: item.organisation_name,
        type: this.getOrgType(item.organisation_type_id)?.label,
        location: `${item?.city || ""}${
          item?.city && item?.country_name ? ", " : ""
        }${item?.country_name || ""}`,
        main_contact: item.contact_name,
        status: _.capitalize(item.current_status),
        rawData: item,
      }));
    },
  },
  methods: {
    ...mapActions([
      "fetchOrganisationTypeList",
      "showToast",
      "scrollTop",
      "fetchNonCustOrgPartnerRelationship",
      "createCusOrgPartnerRelaRequest",
      "updateCusOrgPartnerRelaRequest",
    ]),
    getOrgType(orgTypeId) {
      return this.getOrganisationTypeList.find((org) => org.code === orgTypeId);
    },

    handleChangeSelect(name, value) {
      Vue.set(this.customer, name, value);
    },

    openRequestModal(item, status) {
      this.confirmModal.modalContent =
        status
          ? "Are you sure to raise the partner request?"
          : "Are you sure to cancel the partner request?";
      this.confirmModal.data = item;
      this.confirmModal.status = status;
      this.confirmModal.isShowPopup = true;
    },

    confirmModalCallBack(action) {
      if (action === "Confirm") {
        if (this.confirmModal.status) {
          this.sendRequest(this.confirmModal.data);
        } else {
          this.cancelRequest(this.confirmModal.data);
        }
      }
      this.confirmModal.isShowPopup = false;
    },

    async sendRequest(item) {
      const { customer_organisation_id } = this.getOrgDetail;
      await this.createCusOrgPartnerRelaRequest({
        source_cust_org_id: customer_organisation_id,
        target_cust_org_id: item.customer_org_id,
      });
    },

    async cancelRequest(item) {
      const { customer_organisation_id } = this.getOrgDetail;
      await this.updateCusOrgPartnerRelaRequest({
        source_cust_org_id: customer_organisation_id,
        target_cust_org_id: item.customer_org_id,
        status: "cancelled",
      });
    },
  },
  mounted() {
    const appendAction = [
    this.fetchOrganisationTypeList()];

    if (!this.getOrgDetail?.customer_organisation_id) {
      appendAction.push(this.fetchUser());
    }


    Promise.all(appendAction).finally(async () => {
      await this.fetchNonCustOrgPartnerRelationship();

      this.customer.organisation_type_id = this.getOrgType(
        this.getOrgTypeIDFromAccessToken,
      );
      this.scrollTop();
    });
  },
};
</script>
